import { render, staticRenderFns } from "./AbgeschlosseneBestellungen.vue?vue&type=template&id=e6a0a7ae"
import script from "./AbgeschlosseneBestellungen.vue?vue&type=script&lang=ts"
export * from "./AbgeschlosseneBestellungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports